import React from 'react'
import { BoundingBoxRectangle } from '../../types';

interface Props {
    width: number
    height: number
    ogRect: BoundingBoxRectangle | undefined
    changeCoordinates: (a: BoundingBoxRectangle) => void
}

interface State {}

export default class BoundingBox extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);

        this.state = {
            selected: false,
            x: -1,
            y: -1,
            w: -1,
            h: -1,
        }

    }

    onSelected = (rect: BoundingBoxRectangle) => {
        this.setState({
            selected: true,
            ...rect
        })
        this.props.changeCoordinates(rect)
    }

    render() {
        return (
            <Rector
                ogRect={this.props.ogRect}
                width={this.props.width}
                height={this.props.height}
                onSelected={this.onSelected}
            />
        )
    }
}

interface PropsRector {
    width: number
    height: number
    strokeStyle: string | CanvasGradient | CanvasPattern
    lineWidth: number
    ogRect: BoundingBoxRectangle | undefined
    onSelected: (a: BoundingBoxRectangle) => void
}
interface StateRector {
    rect: BoundingBoxRectangle | undefined
}

class Rector extends React.Component<PropsRector, StateRector> {
    static defaultProps = {
        width: 320,
        height: 200,
        strokeStyle: '#F00',
        lineWidth: 1,
        onSelected: () => { },
    };

    canvas: HTMLCanvasElement | null = null;
    ctx: CanvasRenderingContext2D | null = null;
    isDirty = false;
    isDrag = false;
    startX = -1;
    startY = -1;
    curX = -1;
    curY = -1;

    constructor(props: PropsRector) {
        super(props)
        this.state = {
            rect: this.props.ogRect
        }
    }

    componentDidMount() {
        if(!this.canvas){return}
        this.ctx = this.canvas.getContext('2d')
        if(!this.ctx) { return }
        this.ctx.strokeStyle = this.props.strokeStyle
        this.ctx.lineWidth = this.props.lineWidth
        this.addMouseEvents()
        if (this.props.ogRect) {
            this.removeMouseEvents()
            this.ctx.strokeRect(this.props.ogRect.x, this.props.ogRect.y, this.props.ogRect.w, this.props.ogRect.h)
        }
    }

    updateCanvas = () => {
        if (this.isDrag) {
            requestAnimationFrame(this.updateCanvas)
        }
        if (!this.isDirty) {
            return
        }

        this.ctx?.clearRect(0, 0, this.props.width, this.props.height)
        if (this.isDrag) {
            const rect = {
                x: this.startX,
                y: this.startY,
                w: this.curX - this.startX,
                h: this.curY - this.startY,
            }
            this.setState({ rect: rect })
        }
        if (this.state && this.state.rect) {
            this.ctx?.strokeRect(this.state.rect.x, this.state.rect.y, this.state.rect.w, this.state.rect.h)
        }
        this.isDirty = false
    };

    componentWillUnmount() {
        this.removeMouseEvents()
    }

    addMouseEvents() {
        document.addEventListener('mousedown', this.onMouseDown, false);
        document.addEventListener('mousemove', this.onMouseMove, false);
        document.addEventListener('mouseup', this.onMouseUp, false);
    }

    removeMouseEvents() {
        document.removeEventListener('mousedown', this.onMouseDown, false);
        document.removeEventListener('mousemove', this.onMouseMove, false);
        document.removeEventListener('mouseup', this.onMouseUp, false);
    }

    onMouseDown = (e : MouseEvent) => {
        this.isDrag = true
        this.curX = this.startX = e.offsetX
        this.curY = this.startY = e.offsetY
        requestAnimationFrame(this.updateCanvas)
    };

    onMouseMove = (e: MouseEvent) => {
        if (!this.isDrag) return
        this.curX = e.offsetX
        this.curY = e.offsetY
        this.isDirty = true
    };

    onMouseUp = (e: MouseEvent) => {
        this.isDrag = false
        this.isDirty = true

        const rect = {
            x: Math.min(this.startX, this.curX),
            y: Math.min(this.startY, this.curY),
            w: Math.abs(e.offsetX - this.startX),
            h: Math.abs(e.offsetY - this.startY),
        }
        if (rect.w === 0 || rect.h === 0) { return }
        this.props.onSelected(rect)
        this.removeMouseEvents()
    };

    render() {
        return <canvas
            style={{ zIndex: 100, width: "100%", height: "100%", position: 'absolute', top: '0px', left: '0px' }}
            width={this.props.width}
            height={this.props.height}
            ref={(c) => { if(c) {this.canvas = c }}}
        />
    }
}